import { Component } from '@angular/core';

@Component({
  selector: 'app-file-code-icon',
  templateUrl: './file-code-icon.component.html',
  styleUrl: './file-code-icon.component.scss'
})
export class FileCodeIconComponent {

}
